<template>
  <div
    class="va-chat__message"
    :style="{backgroundColor: value.is_admin ? $themes.primary : undefined}"
    :class="{'va-chat__message--yours': value.is_admin}"
  >

    <div class="va-chat__message-info">
      <div class="va-chat__message-user">
        <router-link :to="{ name: 'user-single', params:{id:value.author.id}}">
          {{ value.author.get_full_name }} <img :src="value.author.avatar">
        </router-link>
      </div>
      <div class="date">{{messageDate}}</div>
      <span class="va-chat__message-read ml-3">
        <va-icon :class="{ 'fa':true, 'fa-eye': value.read,'fa-eye-slash': !value.read}">
        </va-icon>
      </span>
    </div>
    <span class="va-chat__message-images">
      <img :src="image" v-for="(image, i) in value.images" :key="i" >
    </span>
    <span class="va-chat__message-text">
      <pre>{{value.text}}</pre>
    </span>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
  computed: {
    messageDate() {
      return moment(this.value.created_at).format('lll')
    },
  },
}
</script>
<style lang="scss" scoped>
.va-chat {
  &__message {
    &-images {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;

      img {
        max-width: 200px;
        margin: 5px;
        height: auto;
        object-fit: cover;
      }
    }

    &-read {
    }

    &-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;

      .date {
        margin-left: 100px;
      }
    }

    &-user {
      a {
        display: flex;
        align-items: center;
      }

      img {
        width: 50px;
        height: 50px;
        margin-left: 20px;
      }
    }
  }
}
</style>
